import React, { Component } from 'react'

import twaddleIcon from "../images/twaddle_icon.png"

    
const TitleHome = () => (    
    <div className="titleHome">
        <div id="titleBg">
            <div id="titleIconContainer"><img id="titleIcon" src={ twaddleIcon } /></div>
            <span id="title">twaddle</span>
            <ul id="tabList">
                <li><a href="#navigateTeam">team</a></li>
                <li><a href="#">about</a></li>
                <li><a href="#">products</a></li>
            </ul>
        </div>
    </div>
)


export default TitleHome